import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export const AGGRID_COLUMN_TYPES = {
  EMPLOYEE: 'EMPLOYEE',
  // non rendering in itself, used to group sub columns under single header
  HEADER_GROUP: 'HEADER_GROUP',

  REVIEW_GRID_POSITION: 'REVIEW_GRID_POSITION',
  REVIEW_RATING: 'REVIEW_RATING',
  REVIEW_OUTCOME: 'REVIEW_OUTCOME',
  REVIEW_OUTCOME_NEW: 'REVIEW_OUTCOME_NEW',
  REVIEW_STATUS: 'REVIEW_STATUS',

  SIMPLE_TEXT: 'SIMPLE_TEXT',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  DISCIPLINARY_ACTION_STATUS: 'DISCIPLINARY_ACTION_STATUS',
  DECIMAL: 'DECIMAL',
  EMPLOYEE_LIST: 'EMPLOYEE_LIST',
  REVIEW_SUBMISSION_STATUS: 'REVIEW_SUBMISSION_STATUS',
  REVIEW_COMPLETION_STATUS: 'REVIEW_COMPLETION_STATUS',
  REVIEW_CALIBRATION_STATUS: 'REVIEW_CALIBRATION_STATUS',
  REVIEW_PREDICTED_RATING: 'REVIEW_PREDICTED_RATING',
  REVIEW_PREDICTED_GRID_POSITION: 'REVIEW_PREDICTED_GRID_POSITION',
  REVIEW_PREDICTED_PROMOTION_STATUS: 'REVIEW_PREDICTED_PROMOTION_STATUS',
  COMPANY: 'COMPANY',
  LONG: 'LONG',
  INTEGER: 'INTEGER',
  PIE_CHART_MAP: 'PIE_CHART_MAP',
  SPLIT_PROGRESS_MAP: 'SPLIT_PROGRESS_MAP',
};

// id 0 is for prediction calibration view as it comes with id as null, from BE, but a numeric id value is better for FE logic
export const PREDICTION_CALIBRATION_VIEW_ID = 0;

export const getTalentPlanningSingleRowTabularDataApi = ({ calibrationViewId, empId }) => {
  const url = endpoints.performanceReview.talentPlanning.singleRowData;

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { calibrationViewId, empId },
  });
};

const getTalentPlanningTabularDataApi = ({ cohortId, calibrationViewId }) => {
  const isPredictionScorePage = calibrationViewId === String(PREDICTION_CALIBRATION_VIEW_ID);
  const url = isPredictionScorePage
    ? endpoints.performanceReview.talentPlanning.predictiveScoreTable
    : endpoints.performanceReview.talentPlanning.table;

  return sendRequest({
    method: isPredictionScorePage ? 'POST' : 'GET',
    url,
    credentials: 'include',
    queryParams: isPredictionScorePage ? undefined : { cohortId, calibrationViewId },
    body: isPredictionScorePage
      ? {
          reviewCycleId: null,
          cohortId,
          feedbackFormId: null,
        }
      : undefined,
  });
};

export const useGetTalentPlanningTabularData = ({ cohortId, calibrationViewId }) =>
  useQuery(
    [REACT_QUERY_KEYS.talentPlanning.tabularData, cohortId, calibrationViewId],
    () =>
      getTalentPlanningTabularDataApi({ cohortId, calibrationViewId }).then((res) => {
        const { columns, rows } = res.entity;

        return { columns, values: rows };
      }),
    {
      enabled: cohortId !== undefined && calibrationViewId !== undefined,
      retry: false,
    }
  );
